import React from 'react'
import { Icon, Text } from 'components/library'
import { Map, Layer } from './components'
import './MapWidget.css'
import icon from 'assets/img/eye.svg'

class MapWidget extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentTab: 0,
      currentSubtab: false,
      showMenu: true,
      showLayers: true,
      toggleChangeLayer: false,

      currentDropdown: false,
      currentDropdownItem: false,
      currentDropdownValues: [0,0],
    }
  }

  componentDidUpdate(props, state) {
    const layerGroup = this.generateLayerGroup()
    const currentView = layerGroup.find(item => item.isActive)

    if(currentView) {
      this.map.flyTo(currentView.center, currentView.zoom)
    }

    if(state.showMenu !== this.state.showMenu) {
      if(this.timeout) clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        this.map.invalidateSize(true)
      }, 300)
    }
  }

  generateMapMenu() {
    const list = []

    React.Children.map(this.props.children, child => {
      if(child && child.type.displayName === 'MapMenu') {
        React.Children.map(child.props.children, child1 => {
          if(!child1) return

          const item = {
            ...child1.props,
            tabs: [],
          }

          React.Children.map(child1.props.children, child2 => {
            if(child2.type.displayName === 'MapOverlay') {
              item.overlay = child2.props.children
            }

            if(child2.type.displayName === 'MapLayer') {
              item.layer = child2.props.children
            }

            if(child2.type.displayName === 'MapTabs') {
              const tabs = React.Children.toArray(child2.props.children).reduce((acc, curr) => {
                return acc.concat({
                  label: curr.props.label,
                  center: curr.props.center,
                  zoom: curr.props.zoom,
                  showText: curr.props.showText,
                  visible: curr.props.visible,
                  active: curr.props.active,
                  className: curr.props.className,
                  showToggleLayerBtn: curr.props.showToggleLayerBtn,
                  children: curr.props.children,
                })
              }, [])

              item.tabs.push(tabs)
            }
          })

          list.push(item)
        })
      }
    })

    return list
  }

  generateLayerGroup() {
    const list = []

    React.Children.map(this.props.children, (child, childIdx) => {
      if(child && child.type.displayName === 'LayerGroup') {
        React.Children.map(child.props.children, (subchild, subchildIdx) => {
          if(!subchild) return
          list.push({
            ...subchild.props,
            isActive: child.props.active === subchildIdx,
            // isActive: [].concat(child.props.active).join(',') === (subchild.props.active + ','),
          })
        })
      }
    })

    return list
  }

  handleChangeTab = (tab, idx) => {
    this.setState({
      currentTab: idx,
      currentSubtab: false,
      toggleChangeLayer: false,
    }, () => {
      if(tab.center && tab.zoom) {
        this.map.flyTo(tab.center, tab.zoom)
      }
    })
    if(this.props.liftStateTab){this.props.liftStateTab(idx)}
  }

  handleToggleDropdown = dropdownId => {
    this.setState(prevState => ({
      currentDropdown: !prevState.currentDropdown || prevState.currentDropdown !== dropdownId ? dropdownId : false,
    }))
  }

  handleChangeDropdownItem = (dropdownId, item, itemIdx) => {
    this.setState(prevState => {
      let newValues = prevState.currentDropdownValues

      if(dropdownId === 'from') {
        newValues[0] = itemIdx
      }

      if(dropdownId === 'to') {
        newValues[1] = itemIdx
      }

      return {
        currentDropdownValues: newValues,
        currentSubtab: itemIdx,
        currentDropdown: false,
        toggleChangeLayer: false,
      }
    }, () => {
      if(item.center && item.zoom){
        this.map.flyTo(item.center, item.zoom)
      }

      if(this.props.liftStateDropdownValues){this.props.liftStateDropdownValues(this.state.currentDropdownValues)}
      if(this.props.liftStateSubTab){this.props.liftStateSubTab(this.state.currentSubtab)}
    })
  }

  handleChangeSubtab = (tabItm, tabIdx) => {
    this.setState({
      currentSubtab: tabIdx,
      currentDropdown: false,
     })
     if(tabItm.center && tabItm.zoom){
       this.map.flyTo(tabItm.center, tabItm.zoom)
     }
    if(this.props.liftStateSubTab){this.props.liftStateSubTab(tabIdx)}
  }

  handleToggleMenu = e => {
    this.setState(prevState => ({
      showMenu: !prevState.showMenu
    }))
  }

  handleToggleLayers = e => {
    this.setState(prevState => ({
      showLayers: !prevState.showLayers
    }))
  }

  toggleChangeLayer = e => {
    this.setState(prevState => {
      return {
        toggleChangeLayer: !prevState.toggleChangeLayer
      }
    })
    if(this.props.toggleChangeLayer){this.props.toggleChangeLayer(e)}
  }

  render() {
    const mapMenu = this.generateMapMenu()
    const layerGroup = this.generateLayerGroup()

    const currentTabHasToggleBtn = () => {
      const currentItem = mapMenu[this.state.currentTab]

      if(this.state.currentSubtab !== false && this.state.currentTab !== false) {
        const currentTab = currentItem.tabs[0][this.state.currentSubtab]
        return currentTab ? currentTab.showToggleLayerBtn : false
      }

      return false
    }

    return (
      <div className={`Map-widget${this.state.showMenu && mapMenu.length > 1 ? ' is-open' : ''}`}>
        {mapMenu.length > 1 &&
          <div className="Map-widget-menu">
            <div>
              {mapMenu.map((item, idx) => (
                <a key={idx} onClick={() => this.handleChangeTab(item, idx)} className={`${this.state.currentTab === idx ? 'active' : ''}`}>
                  <span className="is-underlined">{item.label}</span>
                  <span><Icon name="chevron-right" /></span>
                </a>
              ))}
            </div>
            <a className="Map-widget-menu-close" onClick={this.handleToggleMenu}>
              {this.state.showMenu ? <Icon name="chevron-left" /> : <Icon name="chevron-right" />}
            </a>
          </div>
        }

        <div className="Map-widget-map">
          <div className={`Map-widget-map-overlay Overlay-on-tab-0${[this.state.currentTab + 1]}`}>
            {mapMenu.map((item, idx) => {
              if(idx === this.state.currentTab) {
                if(item.overlay) {
                  return item.overlay
                }

                if(item.tabs.length > 0) {
                  return (
                    [].concat(item.children).map((itemChild, itemChildIdx) => {
                      return (
                        <div key={itemChildIdx} className={`Map-widget-tabs ${itemChild.props.className}`}>
                          {itemChild.props.dropdown ?
                            <div className={`Map-widget-tabs-dropdown ${this.state.currentDropdown === itemChild.props.dropdown && 'is-active'}`} onClick={() => this.handleToggleDropdown(itemChild.props.dropdown)}>
                              <label>{itemChild.props.dropdownLabel}</label>
                              <Text>
                                {item.tabs.length > 1 && item.tabs[itemChildIdx][this.state.currentDropdownValues[itemChildIdx]].label}
                                {item.tabs.length === 1 && itemChild.props.dropdownTitle}
                              </Text>
                              <i className={`sh-icon sh-icon-${this.state.currentDropdown === itemChild.props.dropdown ? 'arrow-up' : 'arrow-down' }`} />
                            </div>
                          :
                            null
                          }

                          {itemChild.props.dropdown ?
                            this.state.currentDropdown === itemChild.props.dropdown &&
                              <div key={itemChildIdx} className="Map-widget-tabs-tab-click">
                                {item.tabs[itemChildIdx].map((subitem, subidx) => (
                                  <a
                                    key={subidx}
                                    onClick={() => this.handleChangeDropdownItem(itemChild.props.dropdown, subitem, subidx)}
                                    className={`${item.tabs.length > 1
                                      ? (this.state.currentDropdownValues[itemChildIdx] === subidx ? 'active' : '')
                                      : (item.tabs.length === 1 ? (this.state.currentSubtab === subidx ? 'active' : '') : '')
                                    }`}>
                                    {subitem.label}
                                  </a>
                                ))}
                              </div>
                          :
                            <div key={itemChildIdx} className="Map-widget-tabs-tab-click">
                              {item.tabs[itemChildIdx].map((subitem, subidx) => (
                                <a
                                  key={subidx}
                                  onClick={() => this.handleChangeSubtab(subitem, subidx)}
                                  className={`${this.state.currentSubtab === subidx || subitem.visible || (!this.state.currentSubtab && subitem.active) ? 'active' : ''}${subitem.visible ? ' visible' : ''}`}>

                                  <span>{subitem.label}</span>
                                  {subitem.showText && (this.state.currentSubtab === subidx || subitem.visible || (!this.state.currentSubtab && subitem.active)) &&
                                    subitem.showText
                                  }
                                </a>
                              ))}
                            </div>
                          }
                        </div>
                      )
                    })
                  )
                }
              }

              return null
            })}
          </div>

          {currentTabHasToggleBtn() &&
            <div className="Map-widget-tabs-change-layer">
              <div className="Map-widget-tabs-legend">
                <div>
                  <div className="First-legent-item">
                  </div>
                  <p>Inbound</p>
                </div>
                <div>
                  <div className="Second-legent-item">
                  </div>
                  <p>Outbound</p>
                </div>
              </div>
              <div className="Map-widget-tabs-change-layer-btn">
                <p className="Btn-label">De route van/naar rijbaan: </p>
                <label className="switch">
                  <input type="checkbox" checked={this.state.toggleChangeLayer} onChange={() => {}} />
                  <span onClick={(e) => this.toggleChangeLayer(e)} className="slider round">
                    {this.state.toggleChangeLayer &&
                      <span className="Icon-first">A</span>
                    }

                    {!this.state.toggleChangeLayer &&
                      <span className="Icon-last">B</span>
                    }
                  </span>
                </label>
              </div>
            </div>
          }

          <div className="Map-widget-map-base">
            <Map
              getMap={map => this.map = map}
              height={this.props.height}
              options={{
                center: (mapMenu[0] && mapMenu[0].center) || (layerGroup[0] && layerGroup[0].center) || [0,0],
                zoom: (mapMenu[0] && mapMenu[0].zoom) || (layerGroup[0] && layerGroup[0].zoom) || [0,0],
                maxBounds: this.props.mapBounds,
                ...this.props.options,
              }}>
              <Layer url={this.props.mapImage} bounds={this.props.mapBounds} />

              {this.state.showLayers && layerGroup.map((item, idx) => {
                if(item && item.isActive) {
                  return <Layer {...item} key={idx} />
                } else {
                  return null
                }
              })}

              {this.state.showLayers && mapMenu.map((item, idx) => {
                if(idx === this.state.currentTab) {
                  if(item.layer) {
                    return item.layer
                  }

                  if(item.tabs.length > 1) {
                    return item.tabs.map((subitem, subidx) => {
                      return subitem.map((ssitm, ssidx) => {
                        return ssitm.children
                      })
                    })
                  } else {
                    if(item.tabs.length === 1) {
                      return item.tabs.map((subitem, subidx) => {
                        return subitem.map((ssitm, ssidx) => {
                          return ssidx === this.state.currentSubtab || (!this.state.currentSubtab && ssitm.active) ? ssitm.children : null
                        })
                      })
                    }
                  }
                }

                return null
              })}

              {/*this.state.showLayers && mapMenu.length === 0 && this.props.children*/}
            </Map>

            {this.props.showLayersButton &&
              <div className="Map-widget-map-layers" onClick={this.handleToggleLayers}>
                <Text>Hulplaag aan</Text>
                <img src={icon} style={{ width: '3rem' }} alt="" />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

MapWidget.defaultProps = {
  showLayersButton: false
}

export default MapWidget



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/MapWidget.js